import React from 'react'
import ClassNames from 'classnames'
import { Accordion, Section, Button, Image } from '../../components'
import { CartSupplierStyle, CartSupplierItemStyle } from './styled'
import { ICONS } from '../../themes'

class CartSupplierItem extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isDeleteHover: false,
    }
  }

  render() {
    const { className, name, taxID, onClickName, onClickDelete } = this.props
    const { isDeleteHover } = this.state

    return (
      <CartSupplierItemStyle
        className={ClassNames(
          'cart-supplier-item',
          { 'is-hover-delete': isDeleteHover },
          className
        )}
      >
        <div className="detail">
          <div className="name list">
            <div className="label">Name:</div>

            <div className="data">
              <Button className="link" onClick={onClickName}>
                {name}
              </Button>
            </div>
          </div>

          <div className="tax-id list">
            <div className="label">Tax ID:</div>

            <div className="data">{taxID}</div>
          </div>
        </div>

        <Button
          className="link delete"
          onClick={onClickDelete}
          onMouseEnter={() => this.setState({ isDeleteHover: !isDeleteHover })}
          onMouseLeave={() => this.setState({ isDeleteHover: !isDeleteHover })}
        >
          <Image
            src={
              isDeleteHover
                ? ICONS['icon-trash-red.svg']
                : ICONS['icon-trash.svg']
            }
            className="delete"
          />
        </Button>
      </CartSupplierItemStyle>
    )
  }
}

export class CartSupplier extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isCartOpen: false,
      bodyHeight: 0,
    }

    this.myRef = React.createRef()
  }

  static Item = CartSupplierItem

  componentDidUpdate() {
    this.setState({
      bodyHeight: this.myRef.current.querySelector('.accordion-body')
        .scrollHeight,
    })
  }

  render() {
    const {
      className,
      cartHeaderText,
      cartAmount,
      children,
      onClick,
    } = this.props
    const { isCartOpen } = this.state

    return (
      <CartSupplierStyle
        innerRef={this.myRef}
        className={ClassNames('cart-supplier', className)}
        bodyHeight={this.state.bodyHeight}
      >
        <Accordion className="cart" isOpen={isCartOpen}>
          <Accordion.Head
            onClick={() => this.setState({ isCartOpen: !isCartOpen })}
          >
            <Section className="cart-header">
              {cartHeaderText} <span>({cartAmount})</span>
            </Section>
          </Accordion.Head>

          <Accordion.Body>
            <div className="scroll-content">{children}</div>

            <div className="actions">
              <Button className="theme-blue" onClick={onClick}>
                Clear list
              </Button>

              <Button className="theme-green" disabled={true}>
                Create RFQ
              </Button>
            </div>
          </Accordion.Body>
        </Accordion>
      </CartSupplierStyle>
    )
  }
}
